<template>
    <div class="card">
        <div class="card__background mb-1">
            <a :href="education.url" class="card__link">
                <img
                    v-if="education.topEducation"
                    src="/Content/img/vignet_2020.png"
                    class="top-education"
                />
                <span v-if="education.newEducation" class="new-education"
                    >Nieuw!</span
                >
            </a>

            <lazy-background
                v-if="education.imageObject !== null"
                :image="education.imageObject"
            ></lazy-background>

            <div
                class="card__content d-flex justify-content-between align-items-center flex-wrap"
            >
                <span v-if="education.learningPathway !== ''"
                    ><i class="fas fa-location-arrow"></i
                    >{{ education.learningPathway }}</span
                >
                <span v-if="education.level !== ''"
                    ><i class="fas fa-layer-group"></i
                    >{{ education.level }}</span
                >
                <span v-if="education.duration !== ''"
                    ><i class="fas fa-clock"></i>
                    {{ education.duration }}
                </span>
            </div>
        </div>

        <div class="d-flex justify-content-between">
            <h3 class="card__title uppercase">
                {{ education.name }}
            </h3>

            <div class="card__actions">
                <input
                    :id="'favoriteEducation' + education.id"
                    v-model="isFavorite"
                    class="d-none"
                    type="checkbox"
                />
                <label
                    :for="'favoriteEducation' + education.id"
                    class="card__label"
                >
                    <i class="fa-heart fa-lg" :class="favoriteIconClass"></i>
                </label>

                <input
                    v-if="isFavoritesPage"
                    :id="'downloadEducation' + education.id"
                    v-model="isDownload"
                    class="d-none"
                    type="checkbox"
                    @input="changeHandler($event.target.checked)"
                />
                <label
                    v-if="isFavoritesPage"
                    :for="'downloadEducation' + education.id"
                    class="card__label"
                >
                    <i class="fa-lg" :class="downloadIconClass"></i>
                </label>
            </div>
        </div>
    </div>
</template>

<script>
import LazyBackground from '@/components/lazy-background';

export default {
    components: {
        LazyBackground
    },
    props: {
        education: {
            type: Object,
            default() {
                return {};
            }
        },
        isFavoritesPage: {
            type: Boolean,
            default: false
        },
        value: {
            type: Array,
            default() {
                return [];
            }
        }
    },

    data() {
        return {
            isFavorite: false,
            isDownload: false
        };
    },

    computed: {
        favoriteIconClass() {
            return this.isFavorite ? 'fas' : 'far';
        },
        downloadIconClass() {
            return this.isDownload ? 'fas fa-check-square' : 'far fa-square';
        }
    },

    watch: {
        isFavorite(val) {
            if (val) {
                this.$store.commit('addFavorite', this.education.id);
            } else {
                this.$store.commit('removeFavorite', this.education.id);
            }
        }
    },

    created() {
        this.isFavorite = this.$store.getters.getFavoriteById(
            this.education.id
        );
    },

    methods: {
        changeHandler(val) {
            const index = this.value.indexOf(this.education.id);
            const isInArray = index >= 0;
            const result = this.value;

            if (val && !isInArray) {
                result.push(this.education.id);
            } else if (!val && isInArray) {
                result.splice(index, 1);
            }

            this.$emit('input', result);
        }
    }
};
</script>

<style lang="scss">
.top-education {
    position: relative;
    left: 0;
    top: 0;
    width: 64px;
    height: 64px;

    @include media-breakpoint-up(md) {
        width: 150px;
        height: 150px;
    }

    @include media-breakpoint-up(lg) {
        width: 64px;
        height: 64px;
    }

    @include media-breakpoint-up(xl) {
        width: 150px;
        height: 150px;
    }
}

.new-education {
    position: absolute;
    top: 10px;
    right: 0;
    color: $color-white;
    letter-spacing: 0.3px;
    background-color: rgba(0, 0, 0, 0.38);
    font-size: 0.85rem;
    padding: 0.15rem 2rem;
    text-transform: uppercase;

    @include media-breakpoint-up(md) {
        top: 35px;
        font-size: 1.125rem;
        padding: 0.35rem 2rem;
    }

    @include media-breakpoint-up(lg) {
        top: 10px;
        font-size: 0.85rem;
        padding: 0.15rem 2rem;
    }

    @include media-breakpoint-up(xl) {
        top: 35px;
        font-size: 1.125rem;
        padding: 0.35rem 2rem;
    }
}
</style>
